import { PerformanceTargetStrategySupportedStrategiesEnum } from 'generated/resources/graphql'

export type Variables = {
  targetStrategy?: PerformanceTargetStrategySupportedStrategiesEnum | null
  arguments?: number[] | null
  id?: number
}

export enum PerformanceTargetGroupEnum {
  AllEmployees = 'all_employees',
  ByLocations = 'by_locations',
  ByTeams = 'by_teams',
  ManualSelection = 'manual_selection',
  DynamicSelection = 'dynamic_selection',
  ByEmployees = 'by_employees',
}
